import React from 'react';
import Officials from './Officials';
import BreadCrumb from './BreadCrumb';
function OfficialsPage() {
     
    return ( 
        <div className = "container-fluid">
        <BreadCrumb/>
        <Officials />
        </div>
     );
}

export default OfficialsPage;